import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
  component: PropTypes.elementType,
};

export default function RHFTextField({ name, component: Component = TextField, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Component {...field} fullWidth error={!!error} helperText={error?.message} {...other} />
      )}
    />
  );
}
